import CommentItem from "./comment.component";

export default CommentItem;
